// extracted by mini-css-extract-plugin
export default {"myLinkify":"ZL36NaZlzvgoOZ3GCOdy","opponentLinkify":"Jwza6LxSfNLFoxpyNnBA","italic":"OyVYZ0AaJPeBSzagXeAH"};